import React from "react";
import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];
const EASE_OUT = [0.16, 1, 0.3, 1];

// Masked line-by-line reveal. Pass an array of strings (lines).
export const KineticLines = ({ lines = [], className = "", delay = 0, lineClassName = "" }) => (
  <span className={className} aria-label={lines.join(" ")}>
    {lines.map((line, i) => (
      <span key={i} className="reveal-mask" aria-hidden="true">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, ease: EASE, delay: delay + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

// Same but triggered when scrolled into view
export const KineticLinesInView = ({ lines = [], className = "", lineClassName = "" }) => (
  <span className={className} aria-label={lines.join(" ")}>
    {lines.map((line, i) => (
      <span key={i} className="reveal-mask" aria-hidden="true">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          whileInView={{ y: "0%" }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 1, ease: EASE, delay: i * 0.1 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const FadeUp = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8%" }}
    transition={{ duration: 0.9, ease: EASE_OUT, delay }}
  >
    {children}
  </motion.div>
);

export const Stagger = ({ children, className = "" }) => (
  <div className={className}>{children}</div>
);

export const StaggerItem = ({ children, className = "", y = 24 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "0px 0px -5% 0px" }}
    transition={{ duration: 0.7, ease: EASE_OUT }}
  >
    {children}
  </motion.div>
);
